import { render, staticRenderFns } from "./SwitchTeamModal.vue?vue&type=template&id=74916a51"
import script from "./SwitchTeamModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchTeamModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports